//constants
import routes from '../../../../../constants/routes';

//models
import { ElementKind } from '../../../../../models/editor.model';
import { FormulaModel } from '../../../../../models/formula.model';
import { DatasetFiltersType } from './../../../../../models/dataset-filters.model';
import { DatasetFieldModel } from './../../../../../models/dataset.model';

export const generateFiltersURLForDatasetView = (
    datasetId: number,
    filters: DatasetFiltersType,
    fields: DatasetFieldModel[],
): string => {
    if (Object.keys(filters).length) {
        const query: Record<string, string> = {};
        Object.keys(filters).forEach((key: string) => {
            const column = fields.find(
                (field: DatasetFieldModel) =>
                    field.id.toString() === key.toString(),
            );
            if (column) {
                query[column.name] = filters[key].join();
            }
        });
        const queryString = new URLSearchParams(query).toString();
        return routes.datasetsView(datasetId, queryString);
    }
    return routes.datasetsView(datasetId);
};

export const getDatasetFieldIds = (formula: FormulaModel): number[] => {
    let fieldIds: number[] = [];
    if (formula?.deeplink_dataset_field_id) {
        fieldIds.push(+formula?.deeplink_dataset_field_id);
    }
    if (formula?.structure) {
        formula?.structure?.forEach((structure: any) => {
            if (structure.datasetField !== undefined) {
                fieldIds.push(structure.datasetField);
            }
            structure?.children.forEach((child: any) => {
                if (child.kind === ElementKind.dataset) {
                    fieldIds.push(child.datasetField);
                }
            });
        });
    }
    return [...new Set(fieldIds)];
};
